let initialState = {
  paymentState: false,
  paymentDetails: null,
  preloader: false,
  isInvalidated: false,
};

export const PAYMENT_STATE = "assessment_front_service/home/payment_state";
export const PAYMENT_DETAILS = "assessment_front_service/home/paymentDetails";
export const PRELOADER = "assessment_front_service/home/loading";
export const IS_INVALIIDATE_DATA = "assessment_front_service/home/is_invaliidate_data";

const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_INVALIIDATE_DATA: {
      return {
        ...state,
        isInvalidated: action.value,
      };
    }
    case PAYMENT_DETAILS: {
      return {
        ...state,
        paymentDetails: action.value,
      };
    }
    case PRELOADER: {
      return {
        ...state,
        preloader: action.value,
      };
    }
    default:
      return state;
  }
};

export const actions = {
  setInvaliidateData: (value) => ({
    type: IS_INVALIIDATE_DATA,
    value,
  }),
  setPaymentState: (value) => ({
    type: PAYMENT_STATE,
    value,
  }),
  setPaymentDetails: (value) => ({
    type: PAYMENT_DETAILS,
    value,
  }),
  setPreloader: (value) => ({
    type: PRELOADER,
    value,
  }),
};

export const deleteCorporatesDataAPI = (id) => async (dispatch, getState) => {
  try {
    const state = getState();
    // const res = await homeApi.deleteCorporatesApi(id);
    dispatch(actions.setTableData(null))
    // if (res?.data) {
      // dispatch(getCorporatesDataAPI(activeId, 1));
    // }
  } catch (error) {
    
    // if (error.data.error_code === -4) {
    //   dispatch(logoutId());
    // }
  }
};

export const getIsInvalidatedData = (state) => {
  return state.mainReducer.isInvalidated;
};

export const getPaymentState = (state) => {
  return state.mainReducer.paymentState;
};

export const getPaymentDetails = (state) => {
  return state.mainReducer.paymentDetails;
};

export const getPreloader = (state) => {
  return state.mainReducer.preloader;
};

export default mainReducer;
